import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=40a01375&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=40a01375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a01375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a01375')) {
      api.createRecord('40a01375', component.options)
    } else {
      api.reload('40a01375', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=40a01375&scoped=true&", function () {
      api.rerender('40a01375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisteRegister/Classification.vue"
export default component.exports